export default {"src":"/images/6.jpg","width":5472,"height":3648,"aspectRatio":1.5};